import getBrandLogo from '../../helpers/getBrandLogo';

const config = {
  logo: 'iowa-logo',
  logoPath: getBrandLogo(),
  logoSize: 44,
  name: 'ISU Student Health Patient Portal',
  fillColor: '',
  welcomeText: '',
  registrationLinkTitle: 'auth.haveAccount.text',
  phoneNumber: 1,
  email: '@',
  poweredByLogo: true,
};

export default config;



// WEBPACK FOOTER //
// ./src/whitelabel/configs/isu/index.js